export default __webpack_public_path__ + "static/media/bin@1x.74a4155b.svg";